import styled from 'styled-components/macro';
import { FlexAlignRight, FlexColumn } from '../../../../../shared-styles/flex';

export const BindingsContainer = styled.div`
  ${FlexColumn}
  gap: ${(props) => props.theme.spacing(8)};
  margin: ${(props) => props.theme.spacing(20)} 0;
`;

export const CloseButtonContainer = styled.div`
  ${FlexAlignRight}
`;
